import React, { useEffect, useState } from "react";
import {
  Form,
  Input,
  Button,
  Card,
  Row,
  Col,
  Radio,
  message,
  Spin,
} from "antd";
import EndpointFunctions from "../../../utils/Functions/endpointFunctions";
import Endpoints from "../../../api/endpoints";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import PhoneInput from "react-phone-input-2";
const OfficerInformation = ({
  initialValues,
  isLoading,
  shopId,
  onSuccess,
}) => {
  const [form] = Form.useForm();
  const axiosPrivate = useAxiosPrivate();
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [countryCode, setCountryCode] = useState("");

  const handlePhoneChange = (value, country) => {
    if (typeof value === "string") {
      const phoneNumberWithoutCountryCode = value.substring(
        country.dialCode.length
      );
      setCountryCode(country.dialCode);
      setPhoneNumber(phoneNumberWithoutCountryCode);
    }
  };

  useEffect(() => {
    if (initialValues) {
      const formValues = {
        name: initialValues.name || "",
        email: initialValues.email || "",
        notificationPreferences: {
          GENERAL: initialValues.notificationPreferences?.GENERAL || {
            permitNotification: false,
            permitEmail: false,
            permitSms: false,
          },
          PROMOTIONAL: initialValues.notificationPreferences?.PROMOTIONAL || {
            permitNotification: false,
            permitEmail: false,
            permitSms: false,
          },
        },
      };

      // Only set phone values if they're not null
      if (initialValues.phoneNumber && initialValues.countryCode) {
        setPhoneNumber(initialValues.phoneNumber);
        setCountryCode(initialValues.countryCode);
      } else {
        setPhoneNumber("");
        setCountryCode("");
      }

      form.setFieldsValue(formValues);
    }
  }, [initialValues, form]);

  const handleSubmit = async () => {
    const values = await form.validateFields();
    setIsSubmitLoading(true);
    const requestBody = {
      shopId: shopId,
      name: values.name,
      email: values.email,
      phoneNumber: phoneNumber,
      countryCode: countryCode,
    };
    const response = await EndpointFunctions.putData({
      endpointURL: Endpoints.updateShopOfficerDetails,
      axiosPrivate: axiosPrivate,
      data: requestBody,
    });
    if (response.success) {
      message.success("Yetkili bilgileri güncellendi");
      if (onSuccess) {
        onSuccess();
      }
    } else {
      message.error("Yetkili bilgileri güncellenemedi");
    }
    setIsSubmitLoading(false);
  };

  return (
    <Spin spinning={isSubmitLoading}>
      <Card
        style={{ marginTop: 16 }}
        title="Yetkili Bilgileri"
        type="inner"
        extra={
          <Button type="primary" onClick={handleSubmit} loading={isLoading}>
            Kaydet
          </Button>
        }>
        <Form form={form} layout="vertical">
          <Row gutter={[16, 0]}>
            <Col span={12}>
              <Form.Item name="name" label="Yetkili Adı">
                <Input />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item name="email" label="Yetkili E-posta">
                <Input />
              </Form.Item>
            </Col>
            <Col>
              <Form.Item
                label="Telefon Numarası"
                rules={[
                  { required: true, message: "Telefon numarası gereklidir." },
                ]}>
                <PhoneInput
                  value={
                    countryCode && phoneNumber ? countryCode + phoneNumber : ""
                  }
                  country="tr"
                  countryCodeEditable={true}
                  onChange={handlePhoneChange}
                  inputProps={{
                    required: true,
                  }}
                  containerStyle={{
                    width: "100%",
                  }}
                />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item label="Bildirim İzinleri">
                <Row gutter={[16, 16]}>
                  <Col span={24}>
                    <Card title="Genel Bildirim İzinleri" size="small">
                      <Row gutter={[16, 16]}>
                        <Col span={8}>
                          <Form.Item
                            name={[
                              "notificationPreferences",
                              "GENERAL",
                              "permitNotification",
                            ]}
                            label="Uygulama Bildirimi"
                            style={{ marginBottom: 0 }}>
                            <Radio.Group disabled>
                              <Radio value={true}>Açık</Radio>
                              <Radio value={false}>Kapalı</Radio>
                            </Radio.Group>
                          </Form.Item>
                        </Col>
                        <Col span={8}>
                          <Form.Item
                            name={[
                              "notificationPreferences",
                              "GENERAL",
                              "permitEmail",
                            ]}
                            label="E-posta"
                            style={{ marginBottom: 0 }}>
                            <Radio.Group disabled>
                              <Radio value={true}>Açık</Radio>
                              <Radio value={false}>Kapalı</Radio>
                            </Radio.Group>
                          </Form.Item>
                        </Col>
                        <Col span={8}>
                          <Form.Item
                            name={[
                              "notificationPreferences",
                              "GENERAL",
                              "permitSms",
                            ]}
                            label="SMS"
                            style={{ marginBottom: 0 }}>
                            <Radio.Group disabled>
                              <Radio value={true}>Açık</Radio>
                              <Radio value={false}>Kapalı</Radio>
                            </Radio.Group>
                          </Form.Item>
                        </Col>
                      </Row>
                    </Card>
                  </Col>
                  <Col span={24}>
                    <Card title="Promosyon Bildirimi İzinleri" size="small">
                      <Row gutter={[16, 16]}>
                        <Col span={8}>
                          <Form.Item
                            name={[
                              "notificationPreferences",
                              "PROMOTIONAL",
                              "permitNotification",
                            ]}
                            label="Uygulama Bildirimi"
                            style={{ marginBottom: 0 }}>
                            <Radio.Group disabled>
                              <Radio value={true}>Açık</Radio>
                              <Radio value={false}>Kapalı</Radio>
                            </Radio.Group>
                          </Form.Item>
                        </Col>
                        <Col span={8}>
                          <Form.Item
                            name={[
                              "notificationPreferences",
                              "PROMOTIONAL",
                              "permitEmail",
                            ]}
                            label="E-posta"
                            style={{ marginBottom: 0 }}>
                            <Radio.Group disabled>
                              <Radio value={true}>Açık</Radio>
                              <Radio value={false}>Kapalı</Radio>
                            </Radio.Group>
                          </Form.Item>
                        </Col>
                        <Col span={8}>
                          <Form.Item
                            name={[
                              "notificationPreferences",
                              "PROMOTIONAL",
                              "permitSms",
                            ]}
                            label="SMS"
                            style={{ marginBottom: 0 }}>
                            <Radio.Group disabled>
                              <Radio value={true}>Açık</Radio>
                              <Radio value={false}>Kapalı</Radio>
                            </Radio.Group>
                          </Form.Item>
                        </Col>
                      </Row>
                    </Card>
                  </Col>
                </Row>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Card>
    </Spin>
  );
};

export default OfficerInformation;
